import React, { useEffect, useRef } from "react";
import { FaHandshake, FaEnvelope } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Collaboration = () => {
    const { t } = useTranslation();
    const containerRef = useRef(null);

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.fromTo(".contact-anim",
                { opacity: 0, y: 60, scale: 0.97 },
                {
                    opacity: 1, y: 0, scale: 1, duration: 1.2, ease: "power2.out",
                    scrollTrigger: {
                        trigger: ".contact-anim",
                        start: "top 85%",
                        end: "top 60%",
                        toggleActions: "play none none reverse",
                        scrub: 1.2
                    }
                }
            );
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <div ref={containerRef} className="max-w-[1300px] m-auto px-6 sm:px-10 pb-20 font-Crimson">
            <div className="contact-anim contact-section bg-white/60 backdrop-blur-md rounded-3xl p-12 text-center border border-slate-200 shadow-sm mt-10">
                <FaHandshake className="text-4xl mx-auto mb-6 text-lime-500" />
                <h3 className="text-3xl md:text-4xl font-semibold mb-4 text-slate-800">
                    {t("about.collab.title")}
                </h3>
                <p className="text-lg mb-8 text-slate-600 max-w-2xl mx-auto">
                    {t("about.collab.body")}
                </p>
                <a
                    href="mailto:webapp.naim@gmail.com"
                    className="bg-lime-50 text-slate-700 px-8 py-4 rounded-xl font-semibold text-lg border border-lime-200 hover:bg-lime-100 transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 mx-auto w-fit"
                >
                    <FaEnvelope />
                    {t("about.collab.cta")}
                </a>
            </div>
        </div>
    );
};

export default Collaboration;
